'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertCircle, FeatherRotateCcw } from '@subframe/core';
import { Button, PageHeader_Main } from '@/shared/components/ui';
import { useConfiguracaoDaSimulacao } from '../hooks/useConfiguracaoDaSimulacao';
import { useConversaNaTela } from '../hooks/useConversaNaTela';
import { AvisosDaConversa } from './AvisosDaConversa';
import { CamposDeInicio } from './CamposDeInicio';
import { SimulacaoActions } from './SimulacaoActions';
import { SimulacaoAvancoDoRelogio } from './SimulacaoAvancoDoRelogio';
import { SimulacaoChatPreview } from './SimulacaoChatPreview';
export const SimulacaoSetup = () => {
  const $ = _c(78);
  const configuracao = useConfiguracaoDaSimulacao();
  const {
    conversa,
    chat,
    baixar
  } = useConversaNaTela(configuracao.agentName);
  const {
    agents,
    agentsLoading,
    agentsError,
    agentDetailsLoading,
    selectedId
  } = configuracao;
  const t0 = !configuracao.podeIniciar;
  const t1 = conversa.hasMessages && !conversa.paginacao.exportacao.carregando;
  let t2;
  if ($[0] !== baixar || $[1] !== configuracao.iniciar || $[2] !== conversa.hasVisibleMessages || $[3] !== conversa.limpar || $[4] !== conversa.started || $[5] !== t0 || $[6] !== t1) {
    t2 = <PageHeader_Main title="Testar meus agentes" subtitle={"Voc\xEA participa como cliente; a Lexi responde como agente."} actions={<SimulacaoActions started={conversa.started} restartDisabled={t0} hasMessages={t1} hasVisibleMessages={conversa.hasVisibleMessages} onClear={conversa.limpar} onRestart={configuracao.iniciar} onDownload={baixar} />} className="max-w-[1160px] border-0 pb-0" />;
    $[0] = baixar;
    $[1] = configuracao.iniciar;
    $[2] = conversa.hasVisibleMessages;
    $[3] = conversa.limpar;
    $[4] = conversa.started;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== configuracao.erroDoEncerramento || $[9] !== conversa.carregarMais || $[10] !== conversa.exportError || $[11] !== conversa.paginacao.carregando || $[12] !== conversa.paginacao.erro || $[13] !== conversa.paginacao.exportacao || $[14] !== conversa.paginacao.temMais) {
    t3 = <AvisosDaConversa exportacao={conversa.paginacao.exportacao} temMaisEventos={conversa.paginacao.temMais} carregandoEventos={conversa.paginacao.carregando} erroDosEventos={conversa.paginacao.erro} onCarregarMais={conversa.carregarMais} erroDaExportacao={conversa.exportError} erroDoEncerramento={configuracao.erroDoEncerramento} />;
    $[8] = configuracao.erroDoEncerramento;
    $[9] = conversa.carregarMais;
    $[10] = conversa.exportError;
    $[11] = conversa.paginacao.carregando;
    $[12] = conversa.paginacao.erro;
    $[13] = conversa.paginacao.exportacao;
    $[14] = conversa.paginacao.temMais;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 id="configuracao-simulacao" className="text-heading-3 font-heading-3 text-default-font">Configure seu teste</h2>;
    t5 = <p className="text-body text-subtext-color mt-1">Escolha um agente disponível para sua conta.</p>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t4 = $[16];
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <label className="text-caption-bold font-caption-bold text-default-font" htmlFor="agente-simulacao">Agente</label>;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const t7 = selectedId ?? "";
  const t8 = agentsLoading || agents.length === 0 || agentDetailsLoading;
  let t9;
  if ($[19] !== configuracao) {
    t9 = event => configuracao.selecionarAgente(event.target.value);
    $[19] = configuracao;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = agentsLoading ? "Carregando agentes..." : "Selecione um agente";
  let t11;
  if ($[21] !== t10) {
    t11 = <option value="">{t10}</option>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== agents) {
    t12 = agents.map(_temp);
    $[23] = agents;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t13 = <select id="agente-simulacao" value={t7} disabled={t8} onChange={t9} className="focus:border-brand-500 focus:ring-brand-500/10 text-body text-default-font h-10 w-full rounded-[8px] border border-solid border-neutral-200 bg-white px-3 shadow-sm transition-all focus:ring-4 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60">{t11}{t12}</select>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-caption text-subtext-color">O teste usa a configuração em produção.</span>;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== agentsLoading || $[33] !== configuracao.carregarMaisAgentes || $[34] !== configuracao.haMaisAgentes) {
    t15 = configuracao.haMaisAgentes && <Button variant="neutral-secondary" size="small" disabled={agentsLoading} onClick={configuracao.carregarMaisAgentes}>Carregar mais agentes</Button>;
    $[32] = agentsLoading;
    $[33] = configuracao.carregarMaisAgentes;
    $[34] = configuracao.haMaisAgentes;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t13 || $[37] !== t15) {
    t16 = <div className="mt-6 flex flex-col gap-1.5">{t6}{t13}{t14}{t15}</div>;
    $[36] = t13;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== agentsError || $[40] !== configuracao || $[41] !== selectedId) {
    t17 = agentsError && !selectedId && <div role="alert" className="text-error-600 mt-4 flex flex-wrap items-center gap-3"><FeatherAlertCircle /><span>Não foi possível carregar os agentes.</span><Button variant="neutral-secondary" onClick={() => void configuracao.recarregarAgentes()} icon={<FeatherRotateCcw />}>Tentar novamente</Button></div>;
    $[39] = agentsError;
    $[40] = configuracao;
    $[41] = selectedId;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== agents.length || $[44] !== agentsError || $[45] !== agentsLoading) {
    t18 = !agentsLoading && !agentsError && agents.length === 0 && <p className="text-body text-subtext-color mt-4">Nenhum agente disponível para sua conta.</p>;
    $[43] = agents.length;
    $[44] = agentsError;
    $[45] = agentsLoading;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== configuracao.alterarDado || $[48] !== configuracao.errors || $[49] !== configuracao.recarregarAgente || $[50] !== configuracao.situacaoDosCampos || $[51] !== configuracao.valores || $[52] !== configuracao.variables) {
    t19 = <CamposDeInicio situacao={configuracao.situacaoDosCampos} descricao="Os campos mudam conforme o agente selecionado." textoSemAgente={"Selecione um agente para ver os dados necess\xE1rios."} variables={configuracao.variables} valores={configuracao.valores} errors={configuracao.errors} onChange={configuracao.alterarDado} onRecarregar={configuracao.recarregarAgente} />;
    $[47] = configuracao.alterarDado;
    $[48] = configuracao.errors;
    $[49] = configuracao.recarregarAgente;
    $[50] = configuracao.situacaoDosCampos;
    $[51] = configuracao.valores;
    $[52] = configuracao.variables;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  const t20 = !configuracao.podeIniciar;
  const t21 = conversa.started ? "Reiniciar simula\xE7\xE3o" : "Iniciar simula\xE7\xE3o";
  let t22;
  if ($[54] !== configuracao.iniciar || $[55] !== t20 || $[56] !== t21) {
    t22 = <Button className="mt-6 w-full justify-center" disabled={t20} onClick={configuracao.iniciar}>{t21}</Button>;
    $[54] = configuracao.iniciar;
    $[55] = t20;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== configuracao.erroDoInicio) {
    t23 = configuracao.erroDoInicio && <div role="alert" className="text-error-600 mt-3 flex flex-wrap items-center gap-2"><FeatherAlertCircle /><span className="text-caption">{configuracao.erroDoInicio.mensagem}</span></div>;
    $[58] = configuracao.erroDoInicio;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  let t25;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <SimulacaoAvancoDoRelogio />;
    t25 = <p className="text-caption text-subtext-color mt-3">Nenhuma mensagem é enviada pelo WhatsApp.</p>;
    $[60] = t24;
    $[61] = t25;
  } else {
    t24 = $[60];
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t16 || $[63] !== t17 || $[64] !== t18 || $[65] !== t19 || $[66] !== t22 || $[67] !== t23) {
    t26 = <section aria-labelledby="configuracao-simulacao" className="bg-default-background flex min-w-0 flex-col rounded-[16px] border border-solid border-neutral-200 p-6">{t4}{t5}{t16}{t17}{t18}{t19}{t22}{t23}{t24}{t25}</section>;
    $[62] = t16;
    $[63] = t17;
    $[64] = t18;
    $[65] = t19;
    $[66] = t22;
    $[67] = t23;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== chat) {
    t27 = <SimulacaoChatPreview {...chat} />;
    $[69] = chat;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== t26 || $[72] !== t27) {
    t28 = <div className="mt-6 grid w-full max-w-[1160px] grid-cols-1 items-start gap-6 xl:grid-cols-[minmax(340px,1fr)_390px]">{t26}{t27}</div>;
    $[71] = t26;
    $[72] = t27;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  let t29;
  if ($[74] !== t2 || $[75] !== t28 || $[76] !== t3) {
    t29 = <div className="flex h-full w-full flex-col overflow-auto p-6 md:p-9">{t2}{t3}{t28}</div>;
    $[74] = t2;
    $[75] = t28;
    $[76] = t3;
    $[77] = t29;
  } else {
    t29 = $[77];
  }
  return t29;
};
function _temp(agent) {
  return <option key={agent.id} value={agent.id}>{agent.name}</option>;
}